import { useState } from "react";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  FormGroup,
  FormLabel,
  LinearProgress,
  OutlinedInput,
  Typography,
  TextField,
  Divider,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import PerfectScrollbar from "react-perfect-scrollbar";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import Api from "lib/api/httpRequestHelper";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import TableDesireProduct from "./table-desire-product";
import ImagePlaceholder from "components/Image/ImagePlaceholder";

const useStyles = makeStyles({
  img: {
    margin: "auto",
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%",
  },
  buttonStyle: {
    border: "none",
    background: "transparent",
    color: "grey",
    "&:hover": {
      color: "#DF767D",
      textDecoration: "underline",
    },
  },
});

const brandList = [
  {
    Nome: "Karsten",
    IdMarca: 1,
  },
  {
    Nome: "Karsten Decor",
    IdMarca: 2,
  },
  {
    Nome: "Trussardi",
    IdMarca: 3,
  },
];

export default function DialogSelectProductDesireConsumidor360({
  open,
  onClose,
  cpf,
  idLoja,
  idVendedor,
  customerDetail,
  isMobile,
  setHasUpdatedDesireProduct,
}) {
  const snackbar = useSnackbar();
  const classes = { ...useStyles() };
  const [submitting, setSubmitting] = useState(false);
  const [searchingProducts, setSearchingProducts] = useState(false);
  // const [searchingCategories, setSearchingCategories] = useState(false);

  // const [categoriesList, setCategoriesList] = useState([]);
  // const [selectedCategorie, setSelectedCategorie] = useState('');
  const [productFilter, setProductFilter] = useState("");
  const [selectedBrand, setSelectedBrand] = useState(brandList[0]);

  const [productSelected, setProductSelected] = useState(null);
  const [productList, setProductList] = useState([]);
  const [openProductDialog, setOpenProductDialog] = useState(false);
  const [observation, setObservation] = useState("");

  const [totalRegisters, setTotalRegisters] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const formatPhone = customerDetail?.Celular?.replace(/[^\d]+/g, "");
  const number = formatPhone?.substring(2);
  const ddd = formatPhone?.substring(0, 2);

  const handleClose = () => {
    onClose();
  };

  // const handleGetCategoriesList = async() => {
  //   setSearchingCategories(true);

  //   try {
  //     const value = await Api.get("product-category", "product", "", true);
  //     setCategoriesList(value.Result.ListaCategoria);
  //   } catch (error) {
  //     console.log(error);
  //     snackbar.showMessage(
  //       "Ocorreu um erro ao buscar categorias do usuário. Tente novamente mais tarde.",
  //       {
  //         severity: "error",
  //       }
  //     );
  //   } finally {
  //     setSearchingCategories(false);
  //   }
  // };

  const handleGetProductList = async ({ page = 1 }) => {
    setSearchingProducts(true);

    try {
      const data = await Api.get(
        "product-simple-list",
        "product",
        "?page=" +
          (page - 1) +
          `&pageSize=10` +
          "&order=D" +
          "&filter=" +
          productFilter +
          // '&categoria=' + selectedCategorie?.Descricao +
          "&idMarca=" +
          selectedBrand?.IdMarca?.toString() +
          "&idPessoaLoja=" +
          idLoja?.toString(),
        true
      );
      if (data?.Result?.ListaProdutos?.length !== 0) {
        setProductList(data?.Result?.ListaProdutos);
        setTotalRegisters(data?.Result?.TotalRegistros);
        setOpenProductDialog(true);
      }
    } catch (e) {
      console.log(e);
      snackbar.showMessage(e, {
        severity: "error",
      });    } finally {
      setCurrentPage(page);
      setSearchingProducts(false);
    }
  };

  const handleCreateDesireProduct = async () => {
    setSubmitting(true);

    try {
      const res = await Api.post(
        "create-product-desire",
        "action",
        {
          Cpf: cpf?.replace(/\D/g, ""),
          IdPessoaLoja: idLoja?.toString(),
          IdLojaVendedor: idVendedor?.toString(),
          Observacao: observation,
          Ddd: ddd,
          Telefone: number,
          RefBasica: productSelected?.Codigo,
          Nome: customerDetail?.Nome,
        },
        true
      );
      if (res?.Success) {
        snackbar.showMessage(`Produto de desejo cadastrado com sucesso!`, {
          severity: "success",
        });
        setHasUpdatedDesireProduct(true);
      }
    } catch (error) {
      snackbar.showMessage(error, {
        severity: "error",
      });    } finally {
      setProductSelected(null);
      setObservation("");
      setSubmitting(false);
    }
  };

  // useEffect(() => {
  //   handleGetCategoriesList();
  // },[]);

  return (
    <>
      <Dialog
        open={open}
        maxWidth="md"
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
      >
        <DialogTitle>
          <Typography id="alert-dialog-title" variant="h3" component="h3">
            Selecionar Produto de Desejo
          </Typography>
        </DialogTitle>
        <PerfectScrollbar>
          <DialogContent style={{ padding: "1rem 1.5rem 5rem" }}>
            <Grid
              container
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "2rem",
              }}
            >
              <Grid
                item
                xs={isMobile ? 12 : 6}
                style={{ marginBottom: "-1.5rem" }}
              >
                <FormGroup>
                  <AutoCompleteField
                    label="Marca*"
                    onChange={(newValue) => {
                      if (newValue !== "all") {
                        setSelectedBrand(newValue);
                      } else {
                        setSelectedBrand(brandList[0]);
                      }
                    }}
                    value={selectedBrand}
                    options={brandList}
                    disabled={
                      searchingProducts ||
                      // searchingCategories ||
                      submitting
                    }
                    optionIdKey="Nome"
                  />
                </FormGroup>
              </Grid>
              {/* <Grid item xs={isMobile ? 12 : 4} style={{marginBottom:'-1.5rem'}}>
                <FormGroup>
                  <AutoCompleteField
                    label="Categoria*"
                    onChange={(newValue) => {
                      if(newValue !== 'all') {
                        setSelectedCategorie(newValue);
                      } else {
                        setSelectedCategorie('');
                      }
                    }}
                    value={ selectedCategorie }
                    options={categoriesList}
                    disabled={searchingProducts || searchingCategories || submitting}
                    optionLabelKey="Descricao"
                    optionIdKey="Descricao"
                    
                  />
                </FormGroup>
              </Grid> */}
              <Grid item xs={isMobile ? 12 : 6}>
                <FormGroup>
                  <FormLabel>Produto</FormLabel>
                  <OutlinedInput
                    fullWidth
                    disabled={searchingProducts || submitting}
                    type="text"
                    value={productFilter}
                    onChange={(e) => {
                      setProductFilter(e.target.value);
                    }}
                    onInput={(e) => {
                      e.target.value = e.target.value.toString().slice(0, 100);
                    }}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={isMobile ? 12 : 4}>
                <Button
                  variant="contained"
                  onClick={handleGetProductList}
                  disabled={
                    searchingProducts ||
                    productFilter === "" ||
                    // selectedCategorie === '' ||
                    submitting
                  }
                  fullWidth
                >
                  {searchingProducts ? "Pesquisando..." : "Pesquisar"}
                </Button>
              </Grid>
              <Grid
                item
                xs={isMobile ? 12 : 4}
                hidden={openProductDialog || productList?.length === 0}
              >
                <Button
                  className={classes.buttonStyle}
                  style={
                    isMobile
                      ? {
                          width: "100%",
                          marginBottom: "0.5rem",
                          marginTop: "0.75rem",
                        }
                      : { marginBottom: "0rem" }
                  }
                  onClick={() => setOpenProductDialog(true)}
                  disabled={searchingProducts}
                >
                  Ver Produtos
                </Button>
              </Grid>
            </Grid>
            {searchingProducts && (
              <div>
                <span>Buscando produtos...</span>
                <LinearProgress />
              </div>
            )}
            {productSelected && !searchingProducts && (
              <>
                <Divider style={{ margin: "1.5rem 0" }} />
                <Grid
                  container
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <p style={{ fontWeight: "650", marginBottom: "2rem" }}>
                    Produto de Desejo
                  </p>
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: "flex",
                      flexDirection: isMobile ? "column" : "row",
                    }}
                  >
                    <Grid item xs={2}>
                      <ImagePlaceholder
                        className={classes.img}
                        alt="Imagem do item do pedido"
                        src={productSelected?.Foto}
                        width={70}
                        widthOnError={50}
                        imagePreviewTitle={`Produto ${productSelected?.Codigo}`}
                      />
                    </Grid>
                    <Grid item xs={10}>
                      <p style={{ fontWeight: "600", fontSize: "0.85rem" }}>
                        {productSelected?.Nome}
                      </p>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} style={{ marginTop: "2rem" }}>
                    <FormGroup>
                      <FormLabel required>Observação</FormLabel>
                      <TextField
                        name="observacao"
                        required
                        fullWidth
                        multiline
                        rows={2}
                        disabled={submitting}
                        value={observation}
                        variant="outlined"
                        onChange={(e) => setObservation(e.target.value)}
                        onInput={(e) => {
                          e.target.value = e.target.value
                            .toString()
                            .slice(0, 400);
                        }}
                      />
                    </FormGroup>
                  </Grid>
                </Grid>
                <Divider style={{ margin: "0 0 1.5rem" }} />
              </>
            )}
            {!searchingProducts &&
              productList?.length !== 0 &&
              openProductDialog && (
                <TableDesireProduct
                  dataTable={productList}
                  search={handleGetProductList}
                  currentSizePerPage={5}
                  currentPage={currentPage}
                  totalRegistros={totalRegisters}
                  setProductSelected={setProductSelected}
                  onCloseTable={() => {
                    setOpenProductDialog(false);
                  }}
                />
              )}
          </DialogContent>
        </PerfectScrollbar>
        <DialogActions>
          <Button component={Box} onClick={handleClose} disabled={submitting}>
            Cancelar
          </Button>
          <Button
            hidden={!productSelected}
            color="default"
            variant="contained"
            type="button"
            disabled={submitting || observation === ""}
            onClick={handleCreateDesireProduct}
          >
            {submitting ? "Adicionando..." : "Adicionar"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
